import { Component, HostBinding, OnInit } from '@angular/core';
import axios from 'src/app/Service/axios';
import { Location } from '@angular/common';
import { OtherService } from 'src/app/Service/other.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import momentJalaali from 'moment-jalaali';
import { Router } from "@angular/router";
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare let $: any;
@Component({
  selector: 'reportArea',
  templateUrl: './reportAreaComponent.html',
})
export class ReportAreaComponent implements OnInit {
  constructor(private _location: Location,
    private router: Router,
    private notifyService: NotificationService,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService,
    public otherService: OtherService) { }
  GeoFenceData: any;
  domain: any;
  areaData: any;
  fullAreaData: any;
  totalKM: any = 0;
  analysisId: any = 0;
  isSort: boolean = false;
  carId: any;
  strDate: FormControl = new FormControl(momentJalaali().format('jYYYY/jMM/jDD'))
  datatFrom: FormGroup = this.formBuilder.group({
    strDate: new Date().valueOf(),
  });
  dataPeriodTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataWorkAz: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataWorkTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  ngOnInit(): void {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
    this.getArea();
    this.getDomain();
    $('#reporetArea').click(() => {
      this.reportWork();
    });
  }

  ngAfterViewInit(): void {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }

  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`Radyab_GeoFence`, model);
    let respJson = JSON.parse(resp.data);
    this.GeoFenceData = respJson;
  }

  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  }

  deleteBtn = async () => {
    $.confirm({
      title: `آیا از حذف تحلیل های قبلی اطمینان دارید؟ `,
      content: 'در صورت تایید پس از اجرای درخواست دکمه جستجو را مجددا انتخاب کنید',
      type: 'red',
      buttons: {
        ok: {
          text: "تایید",
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            var areaSelection = document.getElementById("areaSelection") as any;
            let model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iGeoFence: areaSelection.value,
              strDate: this.datatFrom.value.strDate
            };
            this.otherService.Showspinner();
            const resp = await axios.post(
              `Delete_MobilesFunctionInDomain `, model
            );
            let respJson = JSON.parse(resp.data);
            this.otherService.nonespinner();
            this.areaData = respJson;
          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
  }

  searchBtn = async () => {
    $.confirm({
      title: `با توجه به زمان بر بودن این فرایند در صورت عدم دریافت نتیجه، مجددا دکمه بررسی را انتخاب کنید. این روند را تا زمانی که بازخورد انتخاب این دکمه، سریعا به اجرا درآید ادامه دهید.`,
      content: '',
      type: 'green',
      buttons: {
        ok: {
          text: "بستن",
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            var areaSelection = document.getElementById("areaSelection") as any;
            var domainDashbord = document.getElementById("domainDashbord") as any;
            var sTime = document.getElementById("sTime") as any;
            var eTime = document.getElementById("eTime") as any;
            var strDate = this.datatFrom.value.strDate;
            var model = {
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
              iGeoFence: areaSelection.value,
              iMobileDomain: domainDashbord.value,
              strDate: strDate,
              strSTime: sTime.value,
              strETime: eTime.value,
            }
            if (model.iGeoFence == "-1") {
              this.notifyService.showError("لطفا محدوده را انتخاب کنید");
              return;
            }
            this.otherService.Showspinner();
            const resp = await axios.post(
              `Report_MobilesFunctionInDomain`, model
            );
            this.totalKM = 0;
            this.otherService.nonespinner();
            resp.data = JSON.parse(resp.data);
            this.areaData = resp.data;
            this.fullAreaData = resp.data;
            this.fullAreaData.forEach((element: any) => {
              this.totalKM = this.totalKM + element.fKM;
            });
            this.totalKM = Math.ceil(this.totalKM);
            return;
          }
        },

      }
    });
  }

  exportexcel() {
    this.otherService.exportexcel("exelAreaReport", "گزارش حضور در محدوده.xlsx")
  }

  filter(e: any) {
    this.areaData = this.fullAreaData.filter((el: any) => {
      return el.strFullName.includes(e.value);
    });
  }

  goBack() {
    this.router.navigateByUrl(`/`);;
  }

  sortTime(item: number) {
    this.isSort = !this.isSort;
    this.areaData.sort((a: any, b: any) => {
      var splita;
      var splitb;
      if (item == 1) {
        var splita = a.strFirstTime.split(":");
        var splitb = b.strFirstTime.split(":");
      }
      else {
        var splita = a.strLastTime.split(":");
        var splitb = b.strLastTime.split(":");
      }

      if (this.isSort) {

        if (parseInt(splita[0]) > parseInt(splitb[0])) return -1;
        if (parseInt(splita[0]) < parseInt(splitb[0])) return 1;
        if (parseInt(splita[1]) > parseInt(splitb[1])) return -1;
        if (parseInt(splita[1]) < parseInt(splitb[1])) return 1;
        if (parseInt(splita[2]) > parseInt(splitb[2])) return -1;
        if (parseInt(splita[2]) < parseInt(splitb[2])) return 1;
        return 0;
      }
      else {
        this.isSort = false;
        if (parseInt(splita[0]) < parseInt(splitb[0])) return -1;
        if (parseInt(splita[0]) > parseInt(splitb[0])) return 1;
        if (parseInt(splita[1]) < parseInt(splitb[1])) return -1;
        if (parseInt(splita[1]) > parseInt(splitb[1])) return 1;
        if (parseInt(splita[2]) < parseInt(splitb[2])) return -1;
        if (parseInt(splita[2]) > parseInt(splitb[2])) return 1;
        return 0;
      }
    });
  }

  setId(id: any) {
    this.carId = id;
  }

  setAnalysisId(id: any) {
    this.analysisId = id;
  }

  report() {

    //window.localStorage.setItem('reportDataZa', this.dataPeriodAz.value.date);

    var areaSelection = document.getElementById("areaSelection") as any;

    window.localStorage.setItem('reportDataTa', this.gurdService.encrypt(this.dataPeriodTa.value.date));

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(this.dataPeriodTa.value.date))

    window.open(`route/${this.carId}/${areaSelection.value}`, "_blank");

    $('#menuModal').modal('hide');

  }

  reportWork() {
    var Stime = document.getElementById('clocks') as any;
    var Etime = document.getElementById('clocke') as any;
    var areaSelection = document.getElementById("areaSelection") as any;
    window.localStorage.setItem('reportDataZa', this.gurdService.encrypt(this.dataWorkAz.value.date));
    window.localStorage.setItem('reportDataTa', this.gurdService.encrypt(this.dataWorkTa.value.date));
    window.localStorage.setItem('reportStime', this.gurdService.encrypt(Stime.value));
    window.localStorage.setItem('reportEtime', this.gurdService.encrypt(Etime.value));
    $('#exampleModalreportArea').modal('hide');
    if (this.analysisId == 2) {
      window.open(`report/${this.carId}/10/${areaSelection.value}`, "_blank");
    }
    if (this.analysisId == 1) {
      window.open(`report/${this.carId}/11/${areaSelection.value}`, "_blank");
    }
  }

  sortBy() {
    if (this.areaData.length > 0) {
      this.areaData.sort((a: any, b: any) => {
        var textA = a.strPersonnelID.toUpperCase();
        var textB = b.strPersonnelID.toUpperCase();
        if (textA > textB)
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
        if (textA < textB)
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        return
      })
    }
  }
}